import { React, memo } from 'react'

const BoardSpacer = () => {
	return (
		<div className="board-spacer">
		</div>
	)
}

export default memo(BoardSpacer)